import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormHidden from '../../components/form/FormHidden/FormHidden';

const FormHiddenContainer = props =>
  <Field
    name={props.name}
    component={FormHidden}
    props={props}
  />
;

FormHiddenContainer.propTypes = {
  name: PropTypes.string
};

export default FormHiddenContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormHiddenContainer.js
 **/